module.exports = __webpack_public_path__ + "static/hpba-piramida-new-mobile-d64016f02d4e392370c18f65d09b711a.svg";